/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_PrivateInputs */

const en_community_invite_private = /** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Access`)
};

const id_community_invite_private = /** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Pribadi`)
};

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const es_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const fr_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const de_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const ja_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const zh_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const ar_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const it_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const ru_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const pt_community_invite_private = en_community_invite_private;

/** @type {(inputs: Community_Invite_PrivateInputs) => LocalizedString} */
const ko_community_invite_private = en_community_invite_private;

/**
* | output |
* | --- |
* | "Private Access" |
*
* @param {Community_Invite_PrivateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_private = /** @type {((inputs?: Community_Invite_PrivateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_PrivateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_private(inputs)
	if (locale === "es") return es_community_invite_private(inputs)
	if (locale === "fr") return fr_community_invite_private(inputs)
	if (locale === "de") return de_community_invite_private(inputs)
	if (locale === "ja") return ja_community_invite_private(inputs)
	if (locale === "zh") return zh_community_invite_private(inputs)
	if (locale === "ar") return ar_community_invite_private(inputs)
	if (locale === "id") return id_community_invite_private(inputs)
	if (locale === "it") return it_community_invite_private(inputs)
	if (locale === "ru") return ru_community_invite_private(inputs)
	if (locale === "pt") return pt_community_invite_private(inputs)
	return ko_community_invite_private(inputs)
});